module.exports = __webpack_public_path__ + "img/icon-payment-nfc.17fb258d.png";